import { IDeductionByDeductionIdRepositoryParams, IDeductionByDeductionIdRepositoryResponse, IDeductionRepository } from "@/core/repositories/deduction";

export class GetDeductionByDeductionIdUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IDeductionByDeductionIdRepositoryParams): Promise<IDeductionByDeductionIdRepositoryResponse> {
    return this.deductionRepository.getDeductionByDeductionId(params);
  }
}
